// extracted by mini-css-extract-plugin
export default {"container":"welcomelayout_container__bmczj","login":"welcomelayout_login__gMq+c","image":"welcomelayout_image__wyDOq"};